[
  {
    "id": "erp",
    "name": "Gestão comercial",
    "desc": "Pedidos, estoque, compras e financeiro.",
    "icon": "bag",
    "brand": ["Metalúrgica Silva", "Matriz · Contagem", "MS"],
    "user": ["Ana Ribeiro", "Gerente comercial", "AR"],
    "tagline": "Pedidos, estoque e financeiro num lugar só.",
    "areas": [
      {
        "id": "inicio",
        "icon": "home",
        "label": "Início",
        "go": "painel"
      },
      {
        "id": "vendas",
        "icon": "bag",
        "label": "Vendas",
        "children": ["Pedidos", "Orçamentos", "Clientes", "Comissões"],
        "count": 12,
        "cap": "Operação"
      },
      {
        "id": "estoque",
        "icon": "box",
        "label": "Estoque",
        "children": ["Produtos", "Movimentações", "Inventário"]
      },
      {
        "id": "compras",
        "icon": "truck",
        "label": "Compras",
        "children": ["Pedidos de compra", "Fornecedores"]
      },
      {
        "id": "fin",
        "icon": "wallet",
        "label": "Financeiro",
        "children": ["Contas a receber", "Contas a pagar", "Fluxo de caixa"],
        "count": 3
      },
      {
        "id": "rel",
        "icon": "chart",
        "label": "Relatórios",
        "go": "relatorio",
        "cap": "Gestão"
      },
      {
        "id": "cfg",
        "icon": "sliders",
        "label": "Configuração",
        "go": "config"
      }
    ],
    "mainArea": "vendas",
    "mainChild": "Pedidos",
    "list": {
      "title": "Pedidos de venda",
      "sub": "128 pedidos em novembro, de 64 clientes.",
      "total": 128,
      "newL": "Novo pedido",
      "cols": [
        ["Número", "id", "id"],
        ["Cliente", "title", "strong"],
        ["Vendedor", "who", "mut"],
        ["Emissão", "d1", "dmut"],
        ["Entrega", "d2", "dmut"],
        ["Situação", "st", "badge"],
        ["Total (R$)", "val", "num"]
      ],
      "slim": ["id", "title", "st", "val"]
    },
    "rows": [
      {
        "id": "PV-10482",
        "title": "Metalúrgica Andrade Ltda.",
        "c3": "Belo Horizonte/MG",
        "who": "Juliana Prado",
        "d1": "03/11/2026",
        "d2": "12/11/2026",
        "st": ["Aprovado", "ok"],
        "val": "48.920,00"
      },
      {
        "id": "PV-10481",
        "title": "Casa das Ferragens BH",
        "c3": "Belo Horizonte/MG",
        "who": "Marcos Lima",
        "d1": "03/11/2026",
        "d2": "10/11/2026",
        "st": ["Aguardando pagamento", "warn"],
        "val": "7.315,40"
      },
      {
        "id": "PV-10480",
        "title": "Construtora Vale Verde",
        "c3": "Nova Lima/MG",
        "who": "Juliana Prado",
        "d1": "02/11/2026",
        "d2": "20/11/2026",
        "st": ["Em separação", "info"],
        "val": "126.400,00"
      },
      {
        "id": "PV-10479",
        "title": "Distribuidora Ouro Fino",
        "c3": "Betim/MG",
        "who": "Rafael Souza",
        "d1": "02/11/2026",
        "d2": "07/11/2026",
        "st": ["Faturado", "ok"],
        "val": "18.762,90"
      },
      {
        "id": "PV-10478",
        "title": "Auto Peças Contorno",
        "c3": "Contagem/MG",
        "who": "Marcos Lima",
        "d1": "01/11/2026",
        "d2": "05/11/2026",
        "st": ["Cancelado", "bad"],
        "val": "2.140,00"
      },
      {
        "id": "PV-10477",
        "title": "Hospital São Lucas",
        "c3": "Belo Horizonte/MG",
        "who": "Rafael Souza",
        "d1": "31/10/2026",
        "d2": "14/11/2026",
        "st": ["Rascunho", "neu"],
        "val": "9.880,00"
      },
      {
        "id": "PV-10476",
        "title": "Padaria Pão de Minas",
        "c3": "Sabará/MG",
        "who": "Juliana Prado",
        "d1": "31/10/2026",
        "d2": "04/11/2026",
        "st": ["Faturado", "ok"],
        "val": "1.204,50"
      },
      {
        "id": "PV-10475",
        "title": "Indústria Têxtil Serra Azul",
        "c3": "Divinópolis/MG",
        "who": "Marcos Lima",
        "d1": "30/10/2026",
        "d2": "18/11/2026",
        "st": ["Aprovado", "ok"],
        "val": "64.035,00"
      },
      {
        "id": "PV-10474",
        "title": "Mercado Bom Preço",
        "c3": "Contagem/MG",
        "who": "Rafael Souza",
        "d1": "30/10/2026",
        "d2": "06/11/2026",
        "st": ["Em separação", "info"],
        "val": "5.610,00"
      },
      {
        "id": "PV-10473",
        "title": "Gráfica Horizonte",
        "c3": "Belo Horizonte/MG",
        "who": "Juliana Prado",
        "d1": "29/10/2026",
        "d2": "05/11/2026",
        "st": ["Faturado", "ok"],
        "val": "2.980,00"
      }
    ],
    "mainIdx": 2,
    "painelSub": "Vendas e financeiro de novembro, até hoje.",
    "kpis": [
      ["Em aberto", "R$ 182.430,00", "up", "+8%", "12 aguardando", "file"],
      ["Faturado no mês", "R$ 1.284.906,40", "up", "86%", "meta R$ 1,5 mi", "chart"],
      ["Ticket médio", "R$ 10.038,33", "dn", "−3%", "128 pedidos", "bag"],
      ["Atrasados", "4", "dn", "2 novos", "entrega vencida", "calendar"]
    ],
    "chart": {
      "title": "Faturamento por mês",
      "unit": "R$ mil",
      "values": [820, 910, 870, 1010, 980, 1120, 1060, 1190, 1150, 1240, 1310, 1285]
    },
    "hbar": {
      "title": "Pedidos por situação",
      "rows": [
        ["Aprovado", 34, "ok"],
        ["Em separação", 21, "info"],
        ["Aguardando pagamento", 18, "warn"],
        ["Faturado", 49, "neu"],
        ["Cancelado", 6, "bad"]
      ]
    },
    "top": {
      "title": "Maiores clientes do mês",
      "cols": ["Cliente", "Pedidos", "Total (R$)"],
      "rows": [
        ["Construtora Vale Verde", "6", "312.480,00"],
        ["Indústria Têxtil Serra Azul", "4", "188.105,00"],
        ["Metalúrgica Andrade Ltda.", "5", "142.930,00"],
        ["Hospital São Lucas", "3", "61.200,00"]
      ]
    },
    "todo": [
      ["warn", "alert", "4 pedidos com entrega vencida"],
      ["info", "clock", "12 orçamentos aguardam resposta do cliente"],
      ["bad", "wallet", "2 títulos vencidos de Construtora Vale Verde"],
      ["ok", "okc", "Fechamento de outubro concluído"]
    ],
    "board": [
      ["Rascunho", "neu"],
      ["Aguardando pagamento", "warn"],
      ["Aprovado", "ok"],
      ["Em separação", "info"],
      ["Faturado", "ok"]
    ],
    "rec": {
      "tabs": [["Resumo"], ["Itens", 5], ["Financeiro", 2], ["Histórico"]],
      "alert": [
        "warn",
        "alert",
        "Cliente com 2 títulos vencidos.",
        "R$ 4.320,00 em aberto desde 15/10. O faturamento precisa da liberação do financeiro."
      ],
      "fields": [
        ["Cliente", "12.345.678/0001-90", "title"],
        ["Vendedor", "Juliana Prado", "sel"],
        ["Condição de pagamento", "30/60/90 dias", "sel"],
        ["Entrega prevista", "20/11/2026", "date"],
        ["Tabela de preço", "Atacado MG", "sel"],
        ["Endereço de entrega", "Av. Amazonas, 4.200 · Gameleira · Belo Horizonte/MG", "full"],
        ["Observações", "Entregar em duas datas: 60% em 20/11 e o restante em 27/11.", "ta"]
      ],
      "sub": {
        "title": "Itens",
        "cols": [
          ["Produto", "s"],
          ["Unidade", "m"],
          ["Qtd.", "n"],
          ["Preço (R$)", "n"],
          ["Total (R$)", "ns"]
        ],
        "rows": [
          ["Tubo galvanizado 2\"", "barra 6 m", "180", "371,05", "66.789,00"],
          ["Viga I 6\"", "m", "320", "142,00", "45.440,00"],
          ["Chapa de aço 3 mm", "kg", "1.250", "8,40", "10.500,00"],
          ["Tinta epóxi cinza", "lata 3,6 L", "12", "189,00", "2.268,00"],
          ["Parafuso sextavado M8", "cx 100", "40", "32,90", "1.316,00"]
        ]
      },
      "summary": [
        ["Subtotal", "126.313,00"],
        ["Desconto (2%)", "−2.526,26"],
        ["Frete", "2.613,26"]
      ],
      "big": ["Total", null, "R$ "],
      "tl": [
        ["Separação iniciada", "Expedição · hoje, 09:12", "info"],
        ["Pedido aprovado", "Ana Ribeiro · 02/11, 16:40", "ok"],
        ["Desconto de 2% liberado", "Ana Ribeiro · 02/11, 16:38", "warn"],
        ["Pedido criado", "Juliana Prado · 02/11, 14:05", "neu"]
      ],
      "primary": ["Faturar pedido", "check"],
      "secondary": ["Duplicar", "copy"],
      "danger": "Cancelar pedido",
      "props": [
        ["user", "Vendedor", "=who"],
        ["calendar", "Entrega", "=d2"],
        ["wallet", "Pagamento", "30/60/90 dias"],
        ["pin", "Cidade", "=c3"]
      ]
    },
    "agenda": {
      "title": "Agenda de entregas",
      "start": 8,
      "events": [
        [0, 8, 2, "Entrega PV-10476 · Pão de Minas", "ok"],
        [0, 14, 1.5, "Visita · Vale Verde", "info"],
        [1, 9, 1, "Reunião de vendas", "neu"],
        [2, 10, 3, "Entrega PV-10479 · Ouro Fino", "ok"],
        [3, 13, 2, "Coleta · Aço Forte", "warn"],
        [4, 8, 1, "Fechamento semanal", "neu"],
        [4, 15, 2, "Entrega PV-10482 · Andrade", "ok"]
      ]
    },
    "gallery": {
      "title": "Catálogo de produtos",
      "sub": "412 produtos ativos.",
      "items": [
        ["Chapa de aço 3 mm", "kg · 4.820 em estoque", "R$ 8,40", ["Em estoque", "ok"], "box"],
        ["Viga I 6\"", "m · 1.230 em estoque", "R$ 142,00", ["Em estoque", "ok"], "box"],
        [
          "Tubo galvanizado 2\"",
          "barra 6 m · 96 em estoque",
          "R$ 371,05",
          ["Baixo", "warn"],
          "box"
        ],
        ["Parafuso sextavado M8", "cx 100 · 40 em estoque", "R$ 32,90", ["Baixo", "warn"], "box"],
        [
          "Tinta epóxi cinza",
          "lata 3,6 L · 0 em estoque",
          "R$ 189,00",
          ["Sem estoque", "bad"],
          "box"
        ],
        ["Cantoneira 1\"", "barra 6 m · 610 em estoque", "R$ 64,20", ["Em estoque", "ok"], "box"]
      ]
    },
    "wizard": {
      "title": "Novo cliente",
      "steps": ["Empresa", "Endereço", "Condições", "Revisão"],
      "fields": [
        ["Razão social", "Construtora Vale Verde Ltda."],
        ["CNPJ", "12.345.678/0001-90"],
        ["Nome fantasia", "Vale Verde"],
        ["Segmento", "Construção civil", "sel"],
        ["E-mail do financeiro", "financeiro@valeverde.com.br"],
        ["Telefone", "(31) 3333-4400"]
      ]
    },
    "chat": {
      "title": "Mensagens",
      "threads": [
        ["Construtora Vale Verde", "Podem entregar dia 20 cedo?", "10:40", 2],
        ["Casa das Ferragens BH", "Boleto pago, segue o comprovante.", "09:12", 0],
        ["Hospital São Lucas", "Precisamos do orçamento revisado.", "ontem", 1],
        ["Distribuidora Ouro Fino", "Recebemos, obrigado.", "ontem", 0]
      ],
      "with": ["Construtora Vale Verde", "Pedido PV-10480 · Juliana Prado"],
      "msgs": [
        ["them", "Bom dia. O pedido PV-10480 já está separando?", "10:31"],
        ["me", "Bom dia. Sim, separação começou hoje às 9h.", "10:35"],
        ["them", "Podem entregar dia 20 cedo? A obra recebe até 10h.", "10:40"]
      ],
      "side": [
        ["Pedido", "PV-10480"],
        ["Total", "R$ 126.400,00"],
        ["Entrega", "20/11/2026"]
      ]
    },
    "report": {
      "title": "Vendas por vendedor",
      "sub": "Novembro de 2026, até hoje.",
      "cols": ["Vendedor", "Pedidos", "Ticket médio (R$)", "Meta", "Total (R$)"],
      "rows": [
        ["Juliana Prado", "52", "11.420,00", "92%", "593.840,00"],
        ["Marcos Lima", "41", "9.880,00", "81%", "405.080,00"],
        ["Rafael Souza", "35", "8.150,00", "74%", "285.250,00"]
      ],
      "foot": ["Total", "128", "10.038,33", "84%", "1.284.170,00"]
    }
  },
  {
    "id": "crm",
    "name": "Clientes e vendas",
    "desc": "Funil de negócios, contatos e atividades.",
    "icon": "target",
    "brand": ["Nexo Software", "Time comercial", "NX"],
    "user": ["Carla Mendes", "Executiva de contas", "CM"],
    "tagline": "Cada negócio no ponto certo do funil.",
    "areas": [
      {
        "id": "inicio",
        "icon": "home",
        "label": "Início",
        "go": "painel"
      },
      {
        "id": "neg",
        "icon": "target",
        "label": "Negócios",
        "children": ["Funil", "Negócios", "Propostas"],
        "count": 8,
        "cap": "Vendas"
      },
      {
        "id": "cont",
        "icon": "users",
        "label": "Contatos",
        "children": ["Pessoas", "Empresas"]
      },
      {
        "id": "ativ",
        "icon": "calendar",
        "label": "Atividades",
        "children": ["Agenda", "Tarefas"],
        "count": 5
      },
      {
        "id": "chat",
        "icon": "chat",
        "label": "Conversas",
        "go": "conversa"
      },
      {
        "id": "rel",
        "icon": "chart",
        "label": "Relatórios",
        "go": "relatorio",
        "cap": "Gestão"
      },
      {
        "id": "cfg",
        "icon": "sliders",
        "label": "Configuração",
        "go": "config"
      }
    ],
    "mainArea": "neg",
    "mainChild": "Negócios",
    "list": {
      "title": "Negócios",
      "sub": "46 negócios abertos, R$ 1,24 mi no funil.",
      "total": 46,
      "newL": "Novo negócio",
      "cols": [
        ["Código", "id", "id"],
        ["Negócio", "title", "strong"],
        ["Empresa", "c3", "mut"],
        ["Responsável", "who", "mut"],
        ["Fechamento", "d2", "dmut"],
        ["Etapa", "st", "badge"],
        ["Valor (R$)", "val", "num"]
      ],
      "slim": ["title", "c3", "st", "val"]
    },
    "rows": [
      {
        "id": "NG-2041",
        "title": "Plano anual · 40 licenças",
        "c3": "Grupo Ômega",
        "who": "Carla Mendes",
        "d1": "Ligar hoje 15h",
        "d2": "28/11/2026",
        "st": ["Proposta", "info"],
        "val": "86.400,00"
      },
      {
        "id": "NG-2040",
        "title": "Implantação e treinamento",
        "c3": "Rede Farma Sul",
        "who": "Bruno Teles",
        "d1": "Reunião 05/11",
        "d2": "15/12/2026",
        "st": ["Negociação", "warn"],
        "val": "142.000,00"
      },
      {
        "id": "NG-2038",
        "title": "Expansão para 3 filiais",
        "c3": "Construtora Vale Verde",
        "who": "Carla Mendes",
        "d1": "Enviar proposta",
        "d2": "10/12/2026",
        "st": ["Qualificação", "neu"],
        "val": "54.000,00"
      },
      {
        "id": "NG-2036",
        "title": "Licenças extras · 12",
        "c3": "Hospital São Lucas",
        "who": "Bruno Teles",
        "d1": "—",
        "d2": "03/11/2026",
        "st": ["Ganho", "ok"],
        "val": "21.600,00"
      },
      {
        "id": "NG-2035",
        "title": "Módulo financeiro",
        "c3": "Distribuidora Ouro Fino",
        "who": "Diego Rocha",
        "d1": "Demonstração 06/11",
        "d2": "20/11/2026",
        "st": ["Reunião marcada", "info"],
        "val": "38.900,00"
      },
      {
        "id": "NG-2033",
        "title": "Plano básico · 10 licenças",
        "c3": "Padaria Pão de Minas",
        "who": "Diego Rocha",
        "d1": "—",
        "d2": "31/10/2026",
        "st": ["Perdido", "bad"],
        "val": "9.600,00"
      },
      {
        "id": "NG-2031",
        "title": "Integração com ERP",
        "c3": "Indústria Têxtil Serra Azul",
        "who": "Carla Mendes",
        "d1": "Revisar contrato",
        "d2": "25/11/2026",
        "st": ["Negociação", "warn"],
        "val": "64.000,00"
      },
      {
        "id": "NG-2030",
        "title": "Contrato de suporte",
        "c3": "Metalúrgica Andrade",
        "who": "Bruno Teles",
        "d1": "Qualificar",
        "d2": "30/12/2026",
        "st": ["Qualificação", "neu"],
        "val": "18.000,00"
      }
    ],
    "mainIdx": 0,
    "painelSub": "Funil e atividades de novembro.",
    "kpis": [
      ["Funil aberto", "R$ 1,24 mi", "up", "+12%", "46 negócios", "target"],
      ["Ganhos no mês", "R$ 312.800,00", "up", "+18%", "9 negócios", "okc"],
      ["Conversão", "23%", "dn", "−2 p.p.", "últimos 90 dias", "chart"],
      ["Atividades atrasadas", "5", "dn", "2 hoje", "precisam de retorno", "clock"]
    ],
    "chart": {
      "title": "Ganhos por mês",
      "unit": "R$ mil",
      "values": [180, 210, 195, 240, 260, 230, 280, 300, 270, 310, 290, 313]
    },
    "hbar": {
      "title": "Negócios por etapa",
      "rows": [
        ["Qualificação", 12, "neu"],
        ["Reunião marcada", 9, "info"],
        ["Proposta", 14, "info"],
        ["Negociação", 11, "warn"]
      ]
    },
    "top": {
      "title": "Maiores negócios abertos",
      "cols": ["Negócio", "Etapa", "Valor (R$)"],
      "rows": [
        ["Implantação · Rede Farma Sul", "Negociação", "142.000,00"],
        ["Plano anual · Grupo Ômega", "Proposta", "86.400,00"],
        ["Integração · Serra Azul", "Negociação", "64.000,00"],
        ["Módulo financeiro · Ouro Fino", "Reunião", "38.900,00"]
      ]
    },
    "todo": [
      ["warn", "clock", "5 atividades atrasadas"],
      ["info", "calendar", "3 reuniões hoje"],
      ["bad", "alert", "Rede Farma Sul pediu desconto acima da alçada"],
      ["ok", "okc", "Meta de outubro batida: 104%"]
    ],
    "board": [
      ["Qualificação", "neu"],
      ["Reunião marcada", "info"],
      ["Proposta", "info"],
      ["Negociação", "warn"],
      ["Ganho", "ok"]
    ],
    "rec": {
      "tabs": [["Resumo"], ["Atividades", 6], ["Propostas", 2], ["Arquivos"]],
      "alert": [
        "info",
        "info",
        "Proposta vista 3 vezes hoje.",
        "O contato abriu o PDF às 09:40, 10:15 e 11:02. Bom momento para ligar."
      ],
      "fields": [
        ["Negócio", "Grupo Ômega · 41 funcionários", "title"],
        ["Contato principal", "Fernanda Lins · Diretora de operações", ""],
        ["Responsável", "Carla Mendes", "sel"],
        ["Etapa", "Proposta", "sel"],
        ["Fechamento previsto", "28/11/2026", "date"],
        ["Origem", "Indicação de cliente", "sel"],
        [
          "Anotações",
          "Quer começar em janeiro. A decisão depende do financeiro aprovar o orçamento de 2027.",
          "ta"
        ]
      ],
      "sub": {
        "title": "Produtos da proposta",
        "cols": [
          ["Produto", "s"],
          ["Qtd.", "n"],
          ["Preço (R$)", "n"],
          ["Total (R$)", "ns"]
        ],
        "rows": [
          ["Licença anual Plus", "40", "1.800,00", "72.000,00"],
          ["Implantação", "1", "9.600,00", "9.600,00"],
          ["Treinamento da equipe", "2", "2.400,00", "4.800,00"]
        ]
      },
      "summary": [
        ["Licenças", "72.000,00"],
        ["Serviços", "14.400,00"]
      ],
      "big": ["Valor", null, "R$ "],
      "tl": [
        ["Proposta aberta 3 vezes", "Fernanda Lins · hoje, 11:02", "info"],
        ["Proposta enviada", "Carla Mendes · 31/10, 17:20", "ok"],
        ["Reunião de descoberta", "Carla Mendes · 28/10, 10:00", "neu"],
        ["Negócio criado", "Indicação · 24/10", "neu"]
      ],
      "primary": ["Marcar como ganho", "okc"],
      "secondary": ["Agendar ligação", "calendar"],
      "danger": "Marcar como perdido",
      "props": [
        ["users", "Empresa", "=c3"],
        ["user", "Responsável", "=who"],
        ["calendar", "Fechamento", "=d2"],
        ["clock", "Próximo passo", "=d1"]
      ]
    },
    "agenda": {
      "title": "Agenda da equipe",
      "start": 8,
      "events": [
        [0, 9, 1, "Ligação · Grupo Ômega", "info"],
        [0, 14, 1.5, "Demonstração · Rede Farma Sul", "warn"],
        [1, 10, 1, "Reunião semanal de vendas", "neu"],
        [2, 9, 2, "Demonstração · Ouro Fino", "info"],
        [2, 15, 1, "Ligação · Serra Azul", "info"],
        [3, 11, 1.5, "Visita · Metalúrgica Andrade", "neu"],
        [4, 16, 1, "Fechamento da semana", "ok"]
      ]
    },
    "gallery": {
      "title": "Empresas",
      "sub": "128 empresas na carteira.",
      "items": [
        [
          "Grupo Ômega",
          "Serviços · São Paulo/SP",
          "2 negócios abertos",
          ["Cliente", "ok"],
          "users"
        ],
        [
          "Rede Farma Sul",
          "Varejo · Porto Alegre/RS",
          "R$ 142 mil em negociação",
          ["Negociando", "warn"],
          "users"
        ],
        [
          "Construtora Vale Verde",
          "Construção · Nova Lima/MG",
          "1 negócio aberto",
          ["Novo", "info"],
          "users"
        ],
        [
          "Hospital São Lucas",
          "Saúde · Belo Horizonte/MG",
          "Cliente desde 2023",
          ["Cliente", "ok"],
          "heart"
        ],
        [
          "Distribuidora Ouro Fino",
          "Atacado · Betim/MG",
          "Demonstração 06/11",
          ["Novo", "info"],
          "users"
        ],
        ["Padaria Pão de Minas", "Alimentação · Sabará/MG", "Perdido em 31/10", null, "users"]
      ]
    },
    "wizard": {
      "title": "Novo negócio",
      "steps": ["Empresa", "Contato", "Proposta", "Revisão"],
      "fields": [
        ["Nome do contato", "Fernanda Lins"],
        ["Cargo", "Diretora de operações"],
        ["E-mail", "fernanda@grupoomega.com.br"],
        ["Telefone", "(11) 98877-6655"],
        ["Como conheceu", "Indicação de cliente", "sel"],
        ["Decide sozinho?", "Não, precisa do financeiro", "sel"]
      ]
    },
    "chat": {
      "title": "Conversas",
      "threads": [
        ["Fernanda Lins", "Podemos falar às 15h?", "11:04", 2],
        ["Rodrigo Prates", "Recebi a proposta, obrigado.", "10:20", 0],
        ["Juliana Ramos", "Qual o prazo de implantação?", "ontem", 1],
        ["Equipe Rede Farma", "Contrato revisado em anexo.", "ontem", 0]
      ],
      "with": ["Fernanda Lins", "Grupo Ômega · Diretora de operações"],
      "msgs": [
        ["them", "Oi, Carla. Vi a proposta, ficou boa.", "10:58"],
        ["them", "Só preciso entender o prazo de implantação para 3 unidades.", "10:59"],
        ["me", "Oi, Fernanda. Fazemos em 30 dias, uma unidade por vez.", "11:01"],
        ["them", "Podemos falar às 15h?", "11:04"]
      ],
      "side": [
        ["Negócio", "NG-2041"],
        ["Valor", "R$ 86.400,00"],
        ["Etapa", "Proposta"]
      ]
    },
    "report": {
      "title": "Ganhos por vendedor",
      "sub": "Novembro de 2026, até hoje.",
      "cols": ["Vendedor", "Negócios", "Ganhos", "Conversão", "Total (R$)"],
      "rows": [
        ["Carla Mendes", "18", "5", "28%", "148.200,00"],
        ["Bruno Teles", "15", "3", "20%", "102.600,00"],
        ["Diego Rocha", "13", "1", "8%", "62.000,00"]
      ],
      "foot": ["Total", "46", "9", "20%", "312.800,00"]
    }
  },
  {
    "id": "clinic",
    "name": "Clínica e consultório",
    "desc": "Agenda, pacientes, prontuário e convênios.",
    "icon": "heart",
    "brand": ["Clínica Bem Viver", "Unidade Savassi", "BV"],
    "user": ["Paula Rezende", "Médica · clínica geral", "PR"],
    "tagline": "A agenda, o prontuário e o caixa da clínica juntos.",
    "areas": [
      {
        "id": "inicio",
        "icon": "home",
        "label": "Início",
        "go": "painel"
      },
      {
        "id": "agenda",
        "icon": "calendar",
        "label": "Agenda",
        "children": ["Semana", "Lista de espera"],
        "count": 18,
        "cap": "Atendimento"
      },
      {
        "id": "atend",
        "icon": "heart",
        "label": "Atendimentos",
        "children": ["Hoje", "Prontuários", "Receitas"]
      },
      {
        "id": "pac",
        "icon": "users",
        "label": "Pacientes",
        "children": ["Todos", "Aniversariantes"]
      },
      {
        "id": "chat",
        "icon": "chat",
        "label": "Mensagens",
        "go": "conversa"
      },
      {
        "id": "fin",
        "icon": "wallet",
        "label": "Financeiro",
        "children": ["Recebimentos", "Convênios", "Repasses"],
        "cap": "Gestão"
      },
      {
        "id": "rel",
        "icon": "chart",
        "label": "Relatórios",
        "go": "relatorio"
      },
      {
        "id": "cfg",
        "icon": "sliders",
        "label": "Configuração",
        "go": "config"
      }
    ],
    "mainArea": "atend",
    "mainChild": "Hoje",
    "list": {
      "title": "Atendimentos de hoje",
      "sub": "18 agendados, 4 já atendidos.",
      "total": 18,
      "newL": "Novo agendamento",
      "cols": [
        ["Horário", "d1", "id"],
        ["Paciente", "title", "strong"],
        ["Profissional", "who", "mut"],
        ["Convênio", "c3", "mut"],
        ["Tipo", "d2", "mut"],
        ["Situação", "st", "badge"],
        ["Valor (R$)", "val", "num"]
      ],
      "slim": ["d1", "title", "st", "val"]
    },
    "rows": [
      {
        "id": "AT-5531",
        "title": "Mariana Costa Alves",
        "c3": "Unimed",
        "who": "Dra. Paula Rezende",
        "d1": "08:00",
        "d2": "Consulta",
        "st": ["Atendido", "ok"],
        "val": "280,00"
      },
      {
        "id": "AT-5532",
        "title": "José Carlos Pereira",
        "c3": "Particular",
        "who": "Dr. Henrique Faria",
        "d1": "08:30",
        "d2": "Retorno",
        "st": ["Atendido", "ok"],
        "val": "0,00"
      },
      {
        "id": "AT-5533",
        "title": "Ana Beatriz Souza",
        "c3": "Bradesco Saúde",
        "who": "Dra. Paula Rezende",
        "d1": "09:00",
        "d2": "Consulta",
        "st": ["Em atendimento", "info"],
        "val": "280,00"
      },
      {
        "id": "AT-5534",
        "title": "Roberto Antunes",
        "c3": "Particular",
        "who": "Dra. Paula Rezende",
        "d1": "09:30",
        "d2": "Consulta",
        "st": ["Aguardando na recepção", "warn"],
        "val": "350,00"
      },
      {
        "id": "AT-5535",
        "title": "Luiza Martins",
        "c3": "Amil",
        "who": "Dr. Henrique Faria",
        "d1": "10:00",
        "d2": "Exame",
        "st": ["Confirmado", "info"],
        "val": "190,00"
      },
      {
        "id": "AT-5536",
        "title": "Pedro Henrique Lima",
        "c3": "Unimed",
        "who": "Dra. Paula Rezende",
        "d1": "10:30",
        "d2": "Consulta",
        "st": ["Confirmado", "info"],
        "val": "280,00"
      },
      {
        "id": "AT-5537",
        "title": "Sônia Ribeiro",
        "c3": "Particular",
        "who": "Dr. Henrique Faria",
        "d1": "11:00",
        "d2": "Procedimento",
        "st": ["Agendado", "neu"],
        "val": "620,00"
      },
      {
        "id": "AT-5538",
        "title": "Carlos Eduardo Nunes",
        "c3": "SulAmérica",
        "who": "Dra. Paula Rezende",
        "d1": "11:30",
        "d2": "Consulta",
        "st": ["Faltou", "bad"],
        "val": "280,00"
      }
    ],
    "mainIdx": 2,
    "painelSub": "Segunda-feira, 3 de novembro. A recepção abriu às 7h30.",
    "kpis": [
      ["Consultas hoje", "18", "up", "+3", "vs. segunda passada", "calendar"],
      ["Recebido no mês", "R$ 86.420,00", "up", "+9%", "meta R$ 110 mil", "wallet"],
      ["Faltas", "6%", "dn", "+1 p.p.", "últimos 30 dias", "alert"],
      ["Lista de espera", "9", "dn", "3 urgentes", "sem horário ainda", "clock"]
    ],
    "chart": {
      "title": "Atendimentos por mês",
      "unit": "atendimentos",
      "values": [410, 388, 452, 470, 495, 460, 512, 530, 498, 541, 560, 575]
    },
    "hbar": {
      "title": "Atendimentos por convênio",
      "rows": [
        ["Unimed", 182, "info"],
        ["Particular", 141, "ok"],
        ["Bradesco Saúde", 96, "neu"],
        ["Amil", 74, "neu"],
        ["SulAmérica", 38, "neu"]
      ]
    },
    "top": {
      "title": "Profissionais no mês",
      "cols": ["Profissional", "Atendimentos", "Recebido (R$)"],
      "rows": [
        ["Dra. Paula Rezende", "212", "38.940,00"],
        ["Dr. Henrique Faria", "176", "31.280,00"],
        ["Dra. Tânia Gomes", "98", "16.200,00"]
      ]
    },
    "todo": [
      ["bad", "alert", "Mariana Costa: resultado de exame alterado"],
      ["warn", "clock", "3 pacientes aguardando na recepção"],
      ["info", "chat", "7 confirmações pendentes para amanhã"],
      ["ok", "okc", "Repasse de outubro enviado aos médicos"]
    ],
    "board": [
      ["Agendado", "neu"],
      ["Confirmado", "info"],
      ["Aguardando na recepção", "warn"],
      ["Em atendimento", "info"],
      ["Atendido", "ok"]
    ],
    "rec": {
      "tabs": [["Atendimento"], ["Prontuário", 12], ["Exames", 3], ["Financeiro"]],
      "alert": [
        "bad",
        "alert",
        "Alergia a dipirona.",
        "Registrada em 12/03/2025. Confira antes de prescrever."
      ],
      "fields": [
        ["Paciente", "34 anos", "title"],
        ["Convênio", "Bradesco Saúde", "sel"],
        ["Carteirinha", "8873 4410 2291 0045", ""],
        ["Profissional", "Dra. Paula Rezende", "sel"],
        ["Tipo", "Consulta", "sel"],
        [
          "Queixa principal",
          "Dor de cabeça frequente há duas semanas, pior no fim do dia.",
          "full"
        ],
        ["Anotações", "Pressão 12x8. Sem febre. Pedir hemograma e avaliar a visão.", "ta"]
      ],
      "sub": {
        "title": "Procedimentos",
        "cols": [
          ["Procedimento", "s"],
          ["Código TUSS", "m"],
          ["Valor (R$)", "ns"]
        ],
        "rows": [
          ["Consulta em consultório", "10101012", "280,00"],
          ["Aferição de pressão", "—", "0,00"]
        ]
      },
      "summary": [
        ["Convênio paga", "280,00"],
        ["Paciente paga", "0,00"]
      ],
      "big": ["Total", null, "R$ "],
      "tl": [
        ["Em atendimento", "Dra. Paula · hoje, 09:04", "info"],
        ["Chegou à recepção", "Recepção · hoje, 08:51", "warn"],
        ["Confirmou por mensagem", "Paciente · ontem, 18:20", "ok"],
        ["Agendado", "Recepção · 28/10, 14:10", "neu"]
      ],
      "primary": ["Finalizar atendimento", "check"],
      "secondary": ["Receita", "file"],
      "danger": "Marcar falta",
      "props": [
        ["clock", "Horário", "=d1"],
        ["user", "Profissional", "=who"],
        ["wallet", "Convênio", "=c3"],
        ["heart", "Tipo", "=d2"]
      ]
    },
    "agenda": {
      "title": "Agenda da semana",
      "start": 8,
      "events": [
        [0, 8, 1, "Mariana Costa · consulta", "ok"],
        [0, 9, 1, "Ana Beatriz · consulta", "info"],
        [0, 11, 2, "Sônia Ribeiro · procedimento", "neu"],
        [1, 8, 4, "Dr. Henrique · plantão", "neu"],
        [2, 14, 1, "Reunião clínica", "warn"],
        [3, 9, 1, "Retorno · José Carlos", "info"],
        [4, 13, 3, "Mutirão de vacinação", "ok"]
      ]
    },
    "gallery": {
      "title": "Profissionais",
      "sub": "6 profissionais nesta unidade.",
      "items": [
        [
          "Dra. Paula Rezende",
          "Clínica geral · CRM 45.112",
          "Hoje: 11 pacientes",
          ["Atendendo", "info"],
          "user"
        ],
        [
          "Dr. Henrique Faria",
          "Cardiologia · CRM 38.904",
          "Hoje: 7 pacientes",
          ["Disponível", "ok"],
          "heart"
        ],
        [
          "Dra. Tânia Gomes",
          "Dermatologia · CRM 51.230",
          "Volta em 10/11",
          ["Férias", "neu"],
          "user"
        ],
        [
          "Marcos Vieira",
          "Fisioterapia · CREFITO 112",
          "Hoje: 9 sessões",
          ["Disponível", "ok"],
          "user"
        ],
        ["Júlia Prado", "Nutrição · CRN 9.877", "Hoje: 5 consultas", ["Disponível", "ok"], "user"],
        [
          "Clara Meireles",
          "Psicologia · CRP 04/5521",
          "Hoje: 6 sessões",
          ["Atendendo", "info"],
          "user"
        ]
      ]
    },
    "wizard": {
      "title": "Novo paciente",
      "steps": ["Dados pessoais", "Contato", "Convênio", "Revisão"],
      "fields": [
        ["Celular", "(31) 98822-1144"],
        ["E-mail", "anabeatriz@email.com"],
        ["CEP", "30140-071"],
        ["Endereço", "Rua Pernambuco, 1.000 · Savassi"],
        ["Como prefere ser lembrado", "Mensagem no celular", "sel"],
        ["Contato de emergência", "Paulo Souza · (31) 99911-2233"]
      ]
    },
    "chat": {
      "title": "Mensagens",
      "threads": [
        ["Roberto Antunes", "Posso remarcar para sexta?", "08:30", 1],
        ["Ana Beatriz Souza", "Chego em 10 minutos.", "08:44", 0],
        ["Luiza Martins", "Confirmado, obrigada.", "ontem", 0],
        ["Pedro Henrique Lima", "Preciso levar algum exame?", "ontem", 2]
      ],
      "with": ["Roberto Antunes", "Particular · consulta hoje, 09:30"],
      "msgs": [
        ["sys", "Lembrete enviado ontem às 18:00", ""],
        ["them", "Bom dia. Vou ter que trabalhar hoje.", "08:29"],
        ["them", "Posso remarcar para sexta?", "08:30"],
        ["me", "Bom dia, Roberto. Sexta temos 10:00 ou 14:30. Qual prefere?", "08:33"]
      ],
      "side": [
        ["Consulta", "hoje, 09:30"],
        ["Profissional", "Dra. Paula"],
        ["Faltas no ano", "1"]
      ]
    },
    "report": {
      "title": "Atendimentos por convênio",
      "sub": "Outubro de 2026.",
      "cols": ["Convênio", "Atendimentos", "Faltas", "Ticket médio (R$)", "Recebido (R$)"],
      "rows": [
        ["Unimed", "182", "9", "268,00", "48.776,00"],
        ["Particular", "141", "4", "342,00", "48.222,00"],
        ["Bradesco Saúde", "96", "7", "255,00", "24.480,00"],
        ["Amil", "74", "6", "240,00", "17.760,00"]
      ],
      "foot": ["Total", "493", "26", "283,00", "139.238,00"]
    }
  },
  {
    "id": "school",
    "name": "Escola e cursos",
    "desc": "Alunos, turmas, notas e mensalidades.",
    "icon": "book",
    "brand": ["Colégio Horizonte", "Fundamental e médio", "CH"],
    "user": ["Márcia Lopes", "Coordenação pedagógica", "ML"],
    "tagline": "Secretaria, sala de aula e financeiro falando a mesma língua.",
    "areas": [
      {
        "id": "inicio",
        "icon": "home",
        "label": "Início",
        "go": "painel"
      },
      {
        "id": "turmas",
        "icon": "book",
        "label": "Turmas",
        "children": ["Turmas", "Horários", "Diário de classe"],
        "cap": "Escola"
      },
      {
        "id": "alunos",
        "icon": "users",
        "label": "Alunos",
        "children": ["Alunos", "Matrículas", "Responsáveis"],
        "count": 6
      },
      {
        "id": "notas",
        "icon": "file",
        "label": "Notas",
        "children": ["Lançar notas", "Boletins"]
      },
      {
        "id": "chat",
        "icon": "chat",
        "label": "Comunicados",
        "go": "conversa"
      },
      {
        "id": "fin",
        "icon": "wallet",
        "label": "Financeiro",
        "children": ["Mensalidades", "Inadimplência"],
        "count": 14,
        "cap": "Gestão"
      },
      {
        "id": "rel",
        "icon": "chart",
        "label": "Relatórios",
        "go": "relatorio"
      },
      {
        "id": "cfg",
        "icon": "sliders",
        "label": "Configuração",
        "go": "config"
      }
    ],
    "mainArea": "alunos",
    "mainChild": "Alunos",
    "list": {
      "title": "Alunos",
      "sub": "612 alunos em 24 turmas.",
      "total": 612,
      "newL": "Nova matrícula",
      "cols": [
        ["Matrícula", "id", "id"],
        ["Aluno", "title", "strong"],
        ["Turma", "c3", "mut"],
        ["Responsável", "who", "mut"],
        ["Frequência", "d1", "dmut"],
        ["Situação", "st", "badge"],
        ["Mensalidade (R$)", "val", "num"]
      ],
      "slim": ["title", "c3", "st", "val"]
    },
    "rows": [
      {
        "id": "2026-0412",
        "title": "Beatriz Almeida Rocha",
        "c3": "7º ano A",
        "who": "Cláudia Rocha",
        "d1": "97%",
        "d2": "",
        "st": ["Matriculado", "ok"],
        "val": "1.380,00"
      },
      {
        "id": "2026-0398",
        "title": "Gabriel Nogueira",
        "c3": "9º ano B",
        "who": "Marcelo Nogueira",
        "d1": "88%",
        "d2": "",
        "st": ["Inadimplente", "bad"],
        "val": "1.380,00"
      },
      {
        "id": "2026-0377",
        "title": "Helena Duarte Campos",
        "c3": "1ª série EM",
        "who": "Patrícia Campos",
        "d1": "95%",
        "d2": "",
        "st": ["Matriculado", "ok"],
        "val": "1.620,00"
      },
      {
        "id": "2026-0365",
        "title": "Lucas Ferreira",
        "c3": "6º ano A",
        "who": "Renata Ferreira",
        "d1": "91%",
        "d2": "",
        "st": ["Documentos pendentes", "warn"],
        "val": "1.380,00"
      },
      {
        "id": "2026-0351",
        "title": "Isabela Torres",
        "c3": "3ª série EM",
        "who": "André Torres",
        "d1": "99%",
        "d2": "",
        "st": ["Matriculado", "ok"],
        "val": "1.620,00"
      },
      {
        "id": "2026-0344",
        "title": "Miguel Santana",
        "c3": "8º ano C",
        "who": "Simone Santana",
        "d1": "76%",
        "d2": "",
        "st": ["Em acompanhamento", "info"],
        "val": "1.380,00"
      },
      {
        "id": "2026-0329",
        "title": "Sofia Martins",
        "c3": "2ª série EM",
        "who": "Paulo Martins",
        "d1": "93%",
        "d2": "",
        "st": ["Matriculado", "ok"],
        "val": "1.620,00"
      },
      {
        "id": "2026-0310",
        "title": "Enzo Barbosa",
        "c3": "5º ano B",
        "who": "Fernanda Barbosa",
        "d1": "—",
        "d2": "",
        "st": ["Trancado", "neu"],
        "val": "1.290,00"
      }
    ],
    "mainIdx": 0,
    "painelSub": "3º bimestre, semana 6 de 10.",
    "kpis": [
      ["Alunos ativos", "612", "up", "+18", "vs. 2025", "users"],
      ["Frequência média", "94%", "up", "+1 p.p.", "neste bimestre", "okc"],
      ["Mensalidades em atraso", "R$ 19.320,00", "dn", "14 famílias", "acima de 30 dias", "wallet"],
      ["Rematrículas 2027", "148", "up", "24%", "meta: 80% até dez.", "file"]
    ],
    "chart": {
      "title": "Mensalidades recebidas",
      "unit": "R$ mil",
      "values": [610, 780, 802, 795, 810, 790, 805, 770, 798, 812, 790, 804]
    },
    "hbar": {
      "title": "Alunos por segmento",
      "rows": [
        ["Fundamental I", 188, "info"],
        ["Fundamental II", 236, "info"],
        ["Ensino médio", 188, "info"]
      ]
    },
    "top": {
      "title": "Turmas com mais faltas",
      "cols": ["Turma", "Alunos", "Frequência"],
      "rows": [
        ["8º ano C", "31", "86%"],
        ["9º ano B", "29", "88%"],
        ["1ª série EM", "34", "90%"],
        ["6º ano A", "28", "91%"]
      ]
    },
    "todo": [
      ["bad", "wallet", "14 famílias com mensalidade atrasada"],
      ["warn", "file", "Notas do 3º bimestre: 5 turmas sem lançamento"],
      ["info", "chat", "Reunião de pais em 12/11: 212 confirmados"],
      ["ok", "okc", "Diário de classe de outubro fechado"]
    ],
    "board": [
      ["Documentos pendentes", "warn"],
      ["Em acompanhamento", "info"],
      ["Inadimplente", "bad"],
      ["Matriculado", "ok"]
    ],
    "rec": {
      "tabs": [["Ficha"], ["Notas", 9], ["Frequência"], ["Financeiro", 1]],
      "alert": [
        "info",
        "info",
        "Acompanhamento pedagógico desde agosto.",
        "Reforço de matemática às terças. Próxima reunião com a família em 14/11."
      ],
      "fields": [
        ["Aluno", "12 anos", "title"],
        ["Turma", "7º ano A", "sel"],
        ["Turno", "Manhã", "sel"],
        ["Responsável financeiro", "Cláudia Rocha", ""],
        ["E-mail do responsável", "claudia.rocha@email.com", ""],
        ["Endereço", "Rua dos Timbiras, 2.250 · Lourdes · Belo Horizonte/MG", "full"],
        ["Observações", "Usa óculos. Senta nas primeiras fileiras.", "ta"]
      ],
      "sub": {
        "title": "Notas do 3º bimestre",
        "cols": [
          ["Disciplina", "s"],
          ["Prova", "n"],
          ["Trabalho", "n"],
          ["Média", "ns"],
          ["Faltas", "n"]
        ],
        "rows": [
          ["Matemática", "7,5", "9,0", "8,1", "2"],
          ["Português", "8,8", "9,5", "9,1", "0"],
          ["Ciências", "8,0", "8,5", "8,2", "1"],
          ["História", "9,2", "9,0", "9,1", "0"],
          ["Inglês", "9,5", "10,0", "9,7", "1"]
        ]
      },
      "summary": [
        ["Frequência", "97%"],
        ["Faltas no ano", "7"]
      ],
      "big": ["Média geral", "8,8", ""],
      "tl": [
        ["Boletim do 2º bimestre enviado", "Secretaria · 15/08", "ok"],
        ["Reunião com a família", "Márcia Lopes · 02/08", "info"],
        ["Rematrícula 2026", "Cláudia Rocha · 10/12/2025", "ok"],
        ["Matrícula", "Secretaria · 2023", "neu"]
      ],
      "primary": ["Emitir boletim", "file"],
      "secondary": ["Enviar comunicado", "chat"],
      "danger": "Trancar matrícula",
      "props": [
        ["book", "Turma", "=c3"],
        ["user", "Responsável", "=who"],
        ["okc", "Frequência", "=d1"],
        ["wallet", "Mensalidade", "R$ 1.380,00"]
      ]
    },
    "agenda": {
      "title": "Horário do 7º ano A",
      "start": 7,
      "events": [
        [0, 7, 2, "Matemática · Prof. Sérgio", "info"],
        [0, 9.5, 1.5, "Português · Profa. Lia", "neu"],
        [1, 7, 1.5, "Ciências · Prof. Caio", "ok"],
        [1, 9, 2, "Educação física", "warn"],
        [2, 7, 2, "História · Profa. Rita", "neu"],
        [3, 8, 2, "Inglês · Teacher Ann", "info"],
        [4, 7, 3, "Avaliação bimestral", "bad"]
      ]
    },
    "gallery": {
      "title": "Turmas",
      "sub": "24 turmas em 2026.",
      "items": [
        ["7º ano A", "Manhã · sala 12", "31 alunos · 95%", null, "book", 0.95],
        ["8º ano C", "Manhã · sala 15", "31 alunos · 86%", ["Atenção", "warn"], "book", 0.86],
        ["9º ano B", "Tarde · sala 21", "29 alunos · 88%", null, "book", 0.88],
        ["1ª série EM", "Manhã · sala 31", "34 alunos · 90%", null, "book", 0.9],
        ["2ª série EM", "Manhã · sala 32", "30 alunos · 93%", null, "book", 0.93],
        ["3ª série EM", "Manhã · sala 33", "28 alunos · 97%", ["Vestibular", "info"], "book", 0.97]
      ]
    },
    "wizard": {
      "title": "Nova matrícula",
      "steps": ["Aluno", "Responsáveis", "Plano", "Revisão"],
      "fields": [
        ["Responsável financeiro", "Cláudia Rocha"],
        ["CPF", "123.456.789-00"],
        ["Parentesco", "Mãe", "sel"],
        ["Celular", "(31) 99876-5432"],
        ["E-mail", "claudia.rocha@email.com"],
        ["Pode buscar o aluno?", "Sim", "sel"]
      ]
    },
    "chat": {
      "title": "Comunicados",
      "threads": [
        ["Família de Gabriel Nogueira", "Vou pagar na sexta.", "09:12", 1],
        ["Pais do 7º ano A", "Reunião de pais dia 12/11", "08:00", 0],
        ["Família de Miguel Santana", "Ele pode fazer a prova depois?", "ontem", 2],
        ["Professores", "Notas até quinta, por favor.", "ontem", 0]
      ],
      "with": ["Família de Gabriel Nogueira", "9º ano B · responsável: Marcelo"],
      "msgs": [
        ["me", "Bom dia, Marcelo. A mensalidade de outubro está em aberto.", "08:50"],
        ["them", "Bom dia. Tive um imprevisto, desculpe.", "09:10"],
        ["them", "Vou pagar na sexta.", "09:12"]
      ],
      "side": [
        ["Aluno", "Gabriel Nogueira"],
        ["Em aberto", "R$ 1.380,00"],
        ["Vencida há", "33 dias"]
      ]
    },
    "report": {
      "title": "Frequência por turma",
      "sub": "3º bimestre de 2026.",
      "cols": ["Turma", "Alunos", "Aulas dadas", "Faltas", "Frequência"],
      "rows": [
        ["6º ano A", "28", "212", "534", "91%"],
        ["7º ano A", "31", "212", "330", "95%"],
        ["8º ano C", "31", "208", "902", "86%"],
        ["9º ano B", "29", "208", "724", "88%"]
      ],
      "foot": ["Total", "119", "840", "2.490", "90%"]
    }
  },
  {
    "id": "projects",
    "name": "Projetos e tarefas",
    "desc": "Projetos, tarefas da equipe e horas.",
    "icon": "folder",
    "brand": ["Estúdio Norte", "Arquitetura e interiores", "EN"],
    "user": ["Lucas Andrade", "Coordenador de projetos", "LA"],
    "tagline": "Cada projeto no prazo, cada hora no lugar.",
    "areas": [
      {
        "id": "inicio",
        "icon": "home",
        "label": "Início",
        "go": "painel"
      },
      {
        "id": "proj",
        "icon": "folder",
        "label": "Projetos",
        "children": ["Ativos", "Arquivados"],
        "count": 9,
        "cap": "Trabalho"
      },
      {
        "id": "tar",
        "icon": "check",
        "label": "Tarefas",
        "children": ["Da equipe", "Quadro", "Minhas tarefas"],
        "count": 7
      },
      {
        "id": "cli",
        "icon": "users",
        "label": "Clientes"
      },
      {
        "id": "horas",
        "icon": "clock",
        "label": "Horas",
        "children": ["Semana", "Aprovações"]
      },
      {
        "id": "chat",
        "icon": "chat",
        "label": "Conversas",
        "go": "conversa"
      },
      {
        "id": "rel",
        "icon": "chart",
        "label": "Relatórios",
        "go": "relatorio",
        "cap": "Gestão"
      },
      {
        "id": "cfg",
        "icon": "sliders",
        "label": "Configuração",
        "go": "config"
      }
    ],
    "mainArea": "tar",
    "mainChild": "Da equipe",
    "list": {
      "title": "Tarefas da equipe",
      "sub": "64 tarefas abertas em 9 projetos.",
      "total": 64,
      "newL": "Nova tarefa",
      "cols": [
        ["Código", "id", "id"],
        ["Tarefa", "title", "strong"],
        ["Projeto", "c3", "mut"],
        ["Responsável", "who", "mut"],
        ["Prazo", "d2", "dmut"],
        ["Situação", "st", "badge"],
        ["Horas", "val", "num"]
      ],
      "slim": ["title", "c3", "st", "d2"]
    },
    "rows": [
      {
        "id": "T-318",
        "title": "Detalhar marcenaria da cozinha",
        "c3": "Apto Lourdes",
        "who": "Bianca Reis",
        "d1": "",
        "d2": "05/11",
        "st": ["Fazendo", "info"],
        "val": "6 h"
      },
      {
        "id": "T-317",
        "title": "Aprovar layout com o cliente",
        "c3": "Casa Pampulha",
        "who": "Lucas Andrade",
        "d1": "",
        "d2": "04/11",
        "st": ["Em revisão", "warn"],
        "val": "2 h"
      },
      {
        "id": "T-315",
        "title": "Orçamento de iluminação",
        "c3": "Loja Savassi",
        "who": "Caio Mendes",
        "d1": "",
        "d2": "07/11",
        "st": ["A fazer", "neu"],
        "val": "4 h"
      },
      {
        "id": "T-314",
        "title": "Render da sala de estar",
        "c3": "Apto Lourdes",
        "who": "Bianca Reis",
        "d1": "",
        "d2": "03/11",
        "st": ["Atrasada", "bad"],
        "val": "8 h"
      },
      {
        "id": "T-312",
        "title": "Visita técnica à obra",
        "c3": "Casa Pampulha",
        "who": "Lucas Andrade",
        "d1": "",
        "d2": "06/11",
        "st": ["A fazer", "neu"],
        "val": "3 h"
      },
      {
        "id": "T-311",
        "title": "Projeto executivo elétrico",
        "c3": "Escritório Funcionários",
        "who": "Caio Mendes",
        "d1": "",
        "d2": "10/11",
        "st": ["Fazendo", "info"],
        "val": "12 h"
      },
      {
        "id": "T-309",
        "title": "Lista de acabamentos",
        "c3": "Loja Savassi",
        "who": "Bianca Reis",
        "d1": "",
        "d2": "01/11",
        "st": ["Feita", "ok"],
        "val": "5 h"
      },
      {
        "id": "T-305",
        "title": "Memorial descritivo",
        "c3": "Escritório Funcionários",
        "who": "Lucas Andrade",
        "d1": "",
        "d2": "30/10",
        "st": ["Feita", "ok"],
        "val": "6 h"
      }
    ],
    "mainIdx": 0,
    "painelSub": "Semana 45: 4 entregas e 2 visitas.",
    "kpis": [
      ["Tarefas abertas", "64", "dn", "−6", "vs. semana passada", "check"],
      ["Atrasadas", "7", "dn", "+2", "precisam de atenção", "alert"],
      ["Horas na semana", "182 h", "up", "91%", "da capacidade", "clock"],
      ["Entregas no mês", "12", "up", "4 feitas", "8 por vir", "folder"]
    ],
    "chart": {
      "title": "Horas por mês",
      "unit": "horas",
      "values": [610, 580, 640, 700, 690, 720, 680, 710, 740, 760, 730, 702]
    },
    "hbar": {
      "title": "Tarefas por situação",
      "rows": [
        ["A fazer", 22, "neu"],
        ["Fazendo", 18, "info"],
        ["Em revisão", 9, "warn"],
        ["Atrasada", 7, "bad"]
      ]
    },
    "top": {
      "title": "Projetos mais perto do prazo",
      "cols": ["Projeto", "Entrega", "Concluído"],
      "rows": [
        ["Casa Pampulha", "15/11", "72%"],
        ["Apto Lourdes", "22/11", "58%"],
        ["Loja Savassi", "05/12", "40%"],
        ["Escritório Funcionários", "18/12", "35%"]
      ]
    },
    "todo": [
      ["bad", "alert", "T-314 Render da sala venceu ontem"],
      ["warn", "clock", "Bianca está com 120% da capacidade"],
      ["info", "users", "Cliente da Casa Pampulha comentou no layout"],
      ["ok", "okc", "Memorial descritivo entregue"]
    ],
    "board": [
      ["A fazer", "neu"],
      ["Fazendo", "info"],
      ["Em revisão", "warn"],
      ["Atrasada", "bad"],
      ["Feita", "ok"]
    ],
    "rec": {
      "tabs": [["Detalhes"], ["Subtarefas", 4], ["Comentários", 6], ["Arquivos", 3]],
      "alert": [
        "warn",
        "alert",
        "Depende de “Aprovar layout com o cliente”.",
        "A tarefa T-317 ainda está em revisão."
      ],
      "fields": [
        ["Tarefa", "Apto Lourdes · Família Moura", "title"],
        ["Responsável", "Bianca Reis", "sel"],
        ["Prazo", "05/11/2026", "date"],
        ["Prioridade", "Alta", "sel"],
        ["Etiquetas", "Marcenaria, Executivo", ""],
        ["Projeto", "Apto Lourdes", "sel"],
        [
          "Descrição",
          "Detalhar armários, ilha e painel ripado. Usar as medidas da visita de 28/10.",
          "ta"
        ]
      ],
      "sub": {
        "title": "Subtarefas",
        "cols": [
          ["Subtarefa", "s"],
          ["Responsável", "m"],
          ["Horas", "ns"]
        ],
        "rows": [
          ["Armários superiores", "Bianca Reis", "2 h"],
          ["Ilha com cooktop", "Bianca Reis", "2 h"],
          ["Painel ripado", "Caio Mendes", "1 h"],
          ["Revisão final", "Lucas Andrade", "1 h"]
        ]
      },
      "summary": [
        ["Estimado", "8 h"],
        ["Lançado", "6 h"]
      ],
      "big": ["Restante", "2 h", ""],
      "tl": [
        ["Bianca lançou 2 h", "hoje, 09:30", "info"],
        ["Cliente comentou no render", "Família Moura · ontem, 19:12", "warn"],
        ["Movida para Fazendo", "Bianca Reis · 31/10", "neu"],
        ["Tarefa criada", "Lucas Andrade · 28/10", "neu"]
      ],
      "primary": ["Concluir tarefa", "check"],
      "secondary": ["Lançar horas", "clock"],
      "danger": "Arquivar",
      "props": [
        ["folder", "Projeto", "=c3"],
        ["user", "Responsável", "=who"],
        ["calendar", "Prazo", "=d2"],
        ["clock", "Horas", "=val"]
      ]
    },
    "agenda": {
      "title": "Semana do estúdio",
      "start": 8,
      "events": [
        [0, 9, 1, "Reunião de pauta", "neu"],
        [0, 14, 2, "Visita · Casa Pampulha", "info"],
        [1, 10, 1.5, "Apresentação · Apto Lourdes", "warn"],
        [2, 8, 4, "Foco: executivo elétrico", "neu"],
        [3, 15, 1, "Fornecedor de marcenaria", "info"],
        [4, 10, 1, "Entrega · Loja Savassi", "ok"],
        [4, 16, 1, "Fechamento de horas", "neu"]
      ]
    },
    "gallery": {
      "title": "Projetos ativos",
      "sub": "9 projetos em andamento.",
      "items": [
        [
          "Casa Pampulha",
          "Residencial · 320 m²",
          "Entrega 15/11",
          ["No prazo", "ok"],
          "home",
          0.72
        ],
        ["Apto Lourdes", "Interiores · 140 m²", "Entrega 22/11", ["Atenção", "warn"], "home", 0.58],
        ["Loja Savassi", "Comercial · 85 m²", "Entrega 05/12", ["No prazo", "ok"], "bag", 0.4],
        [
          "Escritório Funcionários",
          "Corporativo · 210 m²",
          "Entrega 18/12",
          ["No prazo", "ok"],
          "folder",
          0.35
        ],
        ["Clínica Sion", "Saúde · 180 m²", "Começa 20/11", ["Planejado", "neu"], "heart", 0.05],
        [
          "Casa Nova Lima",
          "Residencial · 410 m²",
          "Entrega 30/01",
          ["Atrasado", "bad"],
          "home",
          0.22
        ]
      ]
    },
    "wizard": {
      "title": "Novo projeto",
      "steps": ["Cliente", "Escopo", "Equipe", "Revisão"],
      "fields": [
        ["Tipo de projeto", "Interiores", "sel"],
        ["Área", "140 m²"],
        ["Endereço da obra", "Rua Curitiba, 2.100 · Lourdes"],
        ["Início", "10/11/2026"],
        ["Entrega prevista", "20/02/2027"],
        ["Horas estimadas", "320 h"]
      ]
    },
    "chat": {
      "title": "Conversas",
      "threads": [
        ["Apto Lourdes", "Família Moura: adoramos a ilha!", "10:12", 2],
        ["Equipe", "Caio: subi o executivo.", "09:40", 0],
        ["Casa Pampulha", "Precisamos rever a escada.", "ontem", 1],
        ["Loja Savassi", "Orçamento aprovado.", "ontem", 0]
      ],
      "with": ["Apto Lourdes", "Projeto · Família Moura"],
      "msgs": [
        ["them", "Bom dia! Vimos o render ontem.", "10:10"],
        ["them", "Adoramos a ilha. Dá para ver o painel ripado mais escuro?", "10:12"],
        ["me", "Bom dia. Dá sim, mando duas opções até quinta.", "10:20"]
      ],
      "side": [
        ["Projeto", "Apto Lourdes"],
        ["Etapa", "Executivo"],
        ["Concluído", "58%"]
      ]
    },
    "report": {
      "title": "Horas por projeto",
      "sub": "Outubro de 2026.",
      "cols": ["Projeto", "Estimado", "Lançado", "Diferença", "Concluído"],
      "rows": [
        ["Casa Pampulha", "220 h", "198 h", "−22 h", "72%"],
        ["Apto Lourdes", "160 h", "171 h", "+11 h", "58%"],
        ["Loja Savassi", "90 h", "52 h", "−38 h", "40%"],
        ["Escritório Funcionários", "260 h", "101 h", "−159 h", "35%"]
      ],
      "foot": ["Total", "730 h", "522 h", "−208 h", "52%"]
    }
  },
  {
    "id": "support",
    "name": "Atendimento ao cliente",
    "desc": "Chamados, conversas e base de respostas.",
    "icon": "ticket",
    "brand": ["Conecta Fibra", "Central de atendimento", "CF"],
    "user": ["Rafael Costa", "Supervisor de suporte", "RC"],
    "tagline": "Nenhum cliente esperando sem resposta.",
    "areas": [
      {
        "id": "inicio",
        "icon": "home",
        "label": "Início",
        "go": "painel"
      },
      {
        "id": "cham",
        "icon": "ticket",
        "label": "Chamados",
        "children": ["Fila", "Todos", "Meus chamados"],
        "count": 23,
        "cap": "Atendimento"
      },
      {
        "id": "chat",
        "icon": "chat",
        "label": "Conversas",
        "go": "conversa",
        "count": 4
      },
      {
        "id": "cli",
        "icon": "users",
        "label": "Clientes",
        "children": ["Assinantes", "Empresas"]
      },
      {
        "id": "base",
        "icon": "book",
        "label": "Base de respostas",
        "children": ["Artigos", "Respostas prontas"]
      },
      {
        "id": "equipe",
        "icon": "user",
        "label": "Equipe",
        "children": ["Escala", "Desempenho"],
        "cap": "Gestão"
      },
      {
        "id": "rel",
        "icon": "chart",
        "label": "Relatórios",
        "go": "relatorio"
      },
      {
        "id": "cfg",
        "icon": "sliders",
        "label": "Configuração",
        "go": "config"
      }
    ],
    "mainArea": "cham",
    "mainChild": "Todos",
    "list": {
      "title": "Chamados",
      "sub": "23 abertos, 4 perto de vencer o prazo.",
      "total": 23,
      "newL": "Abrir chamado",
      "cols": [
        ["Chamado", "id", "id"],
        ["Assunto", "title", "strong"],
        ["Cliente", "c3", "mut"],
        ["Agente", "who", "mut"],
        ["Aberto", "d1", "dmut"],
        ["Situação", "st", "badge"],
        ["Prazo", "val", "num"]
      ],
      "slim": ["title", "c3", "st", "val"]
    },
    "rows": [
      {
        "id": "#48213",
        "title": "Internet caindo toda noite",
        "c3": "Bruna Oliveira",
        "who": "Rafael Costa",
        "d1": "há 12 min",
        "d2": "",
        "st": ["Novo", "neu"],
        "val": "1h 48min"
      },
      {
        "id": "#48209",
        "title": "Troca para o plano 600 Mega",
        "c3": "Mercado Bom Preço",
        "who": "Tatiane Melo",
        "d1": "há 40 min",
        "d2": "",
        "st": ["Em andamento", "info"],
        "val": "3h 10min"
      },
      {
        "id": "#48201",
        "title": "Roteador não liga",
        "c3": "Carlos Henrique",
        "who": "Rafael Costa",
        "d1": "há 2 h",
        "d2": "",
        "st": ["Prazo vencido", "bad"],
        "val": "vencido"
      },
      {
        "id": "#48197",
        "title": "Segunda via do boleto",
        "c3": "Padaria Pão de Minas",
        "who": "Tatiane Melo",
        "d1": "há 3 h",
        "d2": "",
        "st": ["Resolvido", "ok"],
        "val": "—"
      },
      {
        "id": "#48190",
        "title": "Visita técnica: sem sinal",
        "c3": "Hospital São Lucas",
        "who": "João Pires",
        "d1": "há 4 h",
        "d2": "",
        "st": ["Em andamento", "info"],
        "val": "40min"
      },
      {
        "id": "#48188",
        "title": "Lentidão no Wi-Fi",
        "c3": "Larissa Moura",
        "who": "João Pires",
        "d1": "há 5 h",
        "d2": "",
        "st": ["Aguardando cliente", "warn"],
        "val": "pausado"
      },
      {
        "id": "#48180",
        "title": "Pedido de cancelamento",
        "c3": "Diego Fontes",
        "who": "Rafael Costa",
        "d1": "ontem",
        "d2": "",
        "st": ["Em andamento", "info"],
        "val": "6h"
      },
      {
        "id": "#48176",
        "title": "Mudança de endereço",
        "c3": "Paula Serra",
        "who": "Tatiane Melo",
        "d1": "ontem",
        "d2": "",
        "st": ["Resolvido", "ok"],
        "val": "—"
      }
    ],
    "mainIdx": 0,
    "painelSub": "Fila de hoje, atualizada agora.",
    "kpis": [
      ["Chamados abertos", "23", "dn", "−5", "desde ontem", "ticket"],
      ["Primeira resposta", "14 min", "up", "−3 min", "média de hoje", "clock"],
      ["Resolvidos hoje", "61", "up", "+12", "vs. ontem", "okc"],
      ["Satisfação", "92%", "up", "+2 p.p.", "últimos 30 dias", "heart"]
    ],
    "chart": {
      "title": "Chamados por mês",
      "unit": "chamados",
      "values": [1820, 1760, 1910, 2040, 1980, 2110, 2060, 1990, 1930, 1880, 1820, 1790]
    },
    "hbar": {
      "title": "Chamados por motivo",
      "rows": [
        ["Sem conexão", 38, "bad"],
        ["Lentidão", 27, "warn"],
        ["Financeiro", 21, "info"],
        ["Troca de plano", 9, "neu"],
        ["Cancelamento", 5, "neu"]
      ]
    },
    "top": {
      "title": "Agentes hoje",
      "cols": ["Agente", "Resolvidos", "Satisfação"],
      "rows": [
        ["Tatiane Melo", "22", "96%"],
        ["João Pires", "18", "91%"],
        ["Rafael Costa", "12", "94%"],
        ["Bruno Alves", "9", "88%"]
      ]
    },
    "todo": [
      ["bad", "alert", "#48201 passou do prazo de resposta"],
      ["warn", "clock", "4 chamados vencem na próxima hora"],
      ["info", "users", "Queda no bairro Prado: 37 clientes afetados"],
      ["ok", "okc", "Fila do nível 2 zerada"]
    ],
    "board": [
      ["Novo", "neu"],
      ["Em andamento", "info"],
      ["Aguardando cliente", "warn"],
      ["Prazo vencido", "bad"],
      ["Resolvido", "ok"]
    ],
    "rec": {
      "tabs": [["Conversa"], ["Detalhes"], ["Equipamentos", 2], ["Histórico", 5]],
      "alert": [
        "bad",
        "alert",
        "O prazo de resposta vence em 1h 48min.",
        "Responda ou passe para o nível 2."
      ],
      "fields": [
        ["Assunto", "plano 300 Mega", "title"],
        ["Agente", "Rafael Costa", "sel"],
        ["Canal", "WhatsApp", "sel"],
        ["Prioridade", "Alta", "sel"],
        ["Endereço", "Rua Platina, 1.420 · Prado · Belo Horizonte/MG", "full"],
        ["Descrição", "A conexão cai entre 22h e 23h desde sábado. Já reiniciou o roteador.", "ta"]
      ],
      "sub": {
        "title": "Equipamentos",
        "cols": [
          ["Equipamento", "s"],
          ["Série", "m"],
          ["Sinal", "ns"]
        ],
        "rows": [
          ["ONU Huawei HG8145", "48575443A1B2", "−21 dBm"],
          ["Roteador Wi-Fi 6", "TPL-99812", "—"]
        ]
      },
      "summary": [
        ["Aberto", "há 12 min"],
        ["Canal", "WhatsApp"]
      ],
      "big": ["Prazo", null, ""],
      "tl": [
        ["Chamado atribuído a Rafael", "Fila automática · 10:30", "info"],
        ["Cliente enviou foto do roteador", "Bruna Oliveira · 10:29", "neu"],
        ["Chamado aberto", "WhatsApp · 10:28", "neu"]
      ],
      "primary": ["Responder", "chat"],
      "secondary": ["Passar para o nível 2", "layers"],
      "danger": "Encerrar sem solução",
      "props": [
        ["users", "Cliente", "=c3"],
        ["user", "Agente", "=who"],
        ["clock", "Aberto", "=d1"],
        ["alert", "Prazo", "=val"]
      ]
    },
    "agenda": {
      "title": "Escala e visitas técnicas",
      "start": 8,
      "events": [
        [0, 8, 4, "João · visitas zona oeste", "info"],
        [0, 13, 5, "Tatiane · plantão do chat", "neu"],
        [1, 8, 2, "Visita · Hospital São Lucas", "warn"],
        [2, 9, 1, "Treinamento: novo roteador", "ok"],
        [3, 8, 4, "João · visitas no Prado", "info"],
        [4, 14, 1, "Reunião de qualidade", "neu"],
        [4, 8, 3, "Manutenção na rede · Prado", "bad"]
      ]
    },
    "gallery": {
      "title": "Base de respostas",
      "sub": "84 artigos publicados.",
      "items": [
        [
          "Como reiniciar o roteador",
          "Conexão · 3 min de leitura",
          "Usado 412 vezes",
          ["Mais usado", "ok"],
          "book"
        ],
        ["Luz vermelha na ONU", "Conexão · 2 min", "Usado 238 vezes", null, "alert"],
        ["Segunda via do boleto", "Financeiro · 1 min", "Usado 190 vezes", null, "wallet"],
        ["Trocar o nome do Wi-Fi", "Wi-Fi · 4 min", "Usado 156 vezes", null, "sliders"],
        ["Mudança de endereço", "Cadastro · 3 min", "Usado 98 vezes", ["Revisar", "warn"], "pin"],
        ["Planos e velocidades", "Comercial · 2 min", "Usado 87 vezes", null, "chart"]
      ]
    },
    "wizard": {
      "title": "Abrir chamado",
      "steps": ["Cliente", "Problema", "Prioridade", "Revisão"],
      "fields": [
        ["Motivo", "Sem conexão", "sel"],
        ["Desde quando", "Sábado, 01/11"],
        ["Já reiniciou o roteador?", "Sim", "sel"],
        ["Luz da ONU", "Vermelha piscando", "sel"],
        ["Melhor horário para visita", "Manhã", "sel"],
        ["Descrição", "A conexão cai entre 22h e 23h.", "ta"]
      ]
    },
    "chat": {
      "title": "Conversas",
      "threads": [
        ["Bruna Oliveira", "A internet caiu de novo agora.", "10:41", 3],
        ["Mercado Bom Preço", "Qual o valor do plano 600?", "10:22", 0],
        ["Larissa Moura", "Vou testar e aviso.", "09:15", 0],
        ["Diego Fontes", "Quero cancelar.", "ontem", 1]
      ],
      "with": ["Bruna Oliveira", "Chamado #48213 · plano 300 Mega"],
      "msgs": [
        ["sys", "Chamado #48213 aberto pelo WhatsApp", ""],
        ["them", "Boa tarde. A internet cai toda noite, umas 22h.", "10:28"],
        ["me", "Oi, Bruna. Estou vendo seu sinal aqui. Ele está bom agora.", "10:35"],
        ["them", "A internet caiu de novo agora.", "10:41"]
      ],
      "side": [
        ["Plano", "300 Mega"],
        ["Cliente desde", "2021"],
        ["Chamados no ano", "3"]
      ]
    },
    "report": {
      "title": "Chamados por motivo",
      "sub": "Outubro de 2026.",
      "cols": ["Motivo", "Chamados", "Tempo médio", "Resolvidos na hora", "Satisfação"],
      "rows": [
        ["Sem conexão", "712", "38 min", "41%", "88%"],
        ["Lentidão", "506", "24 min", "63%", "91%"],
        ["Financeiro", "394", "9 min", "92%", "96%"],
        ["Troca de plano", "168", "12 min", "88%", "97%"]
      ],
      "foot": ["Total", "1.780", "24 min", "64%", "92%"]
    }
  }
]
